import angular from 'angular';
import uiRouter from 'angular-ui-router';
import coderreviewedComponent from './coderreviewed.component';

let coderreviewedModule = angular.module('coderreviewed', [
  uiRouter
])

.component('coderreviewed', coderreviewedComponent);

export default coderreviewedModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/coderreviewed/coderreviewed.js